import { Outlet } from '@tanstack/react-router'
import { useRef } from 'react'
import { Sidebar } from '@/shared/components/layout/Sidebar'
import { TopNav } from '@/shared/components/layout/TopNav'
import { cn } from '@/shared/lib/utils'
import { useAppStore } from '@/shared/stores/appStore'

interface AppLayoutProps {
  /**
   * Optional children to render in place of the default <Outlet />.
   * If no children are provided the standard outlet is used, allowing
   * AppLayout to serve both as a page wrapper and a routing layout.
   */
  children?: React.ReactNode
  breadcrumbs?: React.ReactNode
}

export function AppLayout({ children, breadcrumbs }: AppLayoutProps) {
  const sidebarRef = useRef<{ handleSettingsClick: () => void }>(null)
  const { sidebarCollapsed } = useAppStore()

  const handleSettingsClick = () => {
    sidebarRef.current?.handleSettingsClick()
  }

  return (
    <div className='h-screen bg-background'>
      <TopNav onSettingsClick={handleSettingsClick} breadcrumbs={breadcrumbs} />
      <Sidebar
        ref={sidebarRef}
        className='fixed left-0 top-16 h-[calc(100vh-4rem)] z-30'
      />
      <main
        className={cn(
          'fixed top-16 bottom-0 right-0 overflow-auto transition-all duration-200',
          sidebarCollapsed ? 'left-16' : 'left-64'
        )}
      >
        {children ?? <Outlet />}
      </main>
    </div>
  )
}
